<template>
    <div>
    <!-- 练球卡 -->
    <div v-if="'DAYS_CARD'==type" class="cyclecard" @click="goTo(course.id)">
        <div class="cyclecard-body">
            <div class="clear">
                <div class="left"><h3 class="fs5">{{ course.title }}</h3></div>               
                <div class="right"><i class="iconfont fs5" @click.stop="qrcode('clubPracticeCard')">&#xe63e;</i></div>
            </div>
        </div>
        <div class="cyclecard-footer mtw clear">
            <div class="clear fs2 mbn">剩余练球次数：{{course.remainingNum}}/{{course.totalNum}}</div>
            <div class="clear fs2 mbn">有效期至：{{ conversionTime }}</div>
            <div class="left cyclecard-footer__price">{{ course.price }}</div>
            <div class="right fs1 c6">*需要在线预约</div>
        </div>
    </div>
    <!-- 月卡 -->
    <div v-else class="cyclecard">
        <div class="cyclecard-body">
            <div class="clear">
                <div class="left"><h3 class="fs5">{{ course.title }}</h3></div> 
                <div class="right"><i class="iconfont fs5" @click.stop="qrcode('clubMonthCard')">&#xe63e;</i></div>              
            </div>            
        </div>
        <div class="cyclecard-footer mtw clear">
            <div class="clear fs2 mbn">有效期至：{{ conversionTime }}</div>
            <div class="left cyclecard-footer__price">{{ course.price }}</div>
            <div class="right fs1 c6">*随到随学，有专业教练指导</div>
        </div>
    </div>
    <!-- 二维码 -->
    <div id="qrcodeWrap" class="qrcode-wrap" v-show="showcode" @click="cancleQrcode()"><div id="qrcode"></div></div>    
    </div>
</template>
<script>
import QRCode from 'qrcodejs2'
import moment from 'moment';
moment.locale('zh-cn');

export default {
    name: 'MyCycleCard',    
    props: {
      course: { // 卡信息
        type: Object,
        required: true
      },
      type:{},  //卡类型
    },
    data(){
        return{
            showcode:false
        }
    },
    methods: {
        goTo(id){
            //跳转
            this.$router.push({ name: 'mycarditem', params: { courseId: id}})
        },
        qrcode (type) {
            // console.log(`${location.origin}/venue/#/scancodewriteoff?type=order&relateId=${this.course.orderId}&targetType=${type}`)
            this.showcode = true;
            let qrcode = new QRCode('qrcode', {
                width: 150,
                height: 150, // 高度
                text: `${location.origin}/venue/#/scancodewriteoff?type=order&relateId=${this.course.orderId}&targetType=${type}`, // 二维码内容 网址为http或https开头
                // render: 'canvas' // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
                // background: '#f0f'
                // foreground: '#ff0'
            })
        },
        cancleQrcode(){
            this.showcode = false;
            document.getElementById('qrcodeWrap').innerHTML='<div id="qrcode"></div>'
        }
    },
    computed: {
        conversionTime: function () {
            return moment(this.course.endTime*1000).format('YYYY-MM-DD')
        }
    }
}
</script>
<style lang="less">
@mg-default:.15rem;
.cyclecard{ 
    display: block;
    position: relative;
    height: 1.4rem;
    margin-top: .15rem;
    padding:.1rem; 
    font-size: .16rem;
    border-radius: .03rem; 
    box-shadow: rgba(222,195,155,.2) 0 0 .05rem; 
    color: #5f390c;
    z-index: 1;
    background: linear-gradient(to right bottom,rgba(222,195,155,.8),rgba(194,165,90,.8) 60%,rgba(244,215,178,.8));
    // &:before{
    //     content: 'cycle CARD';
    //     font-family:'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    //     display: block;
    //     position: absolute;
    //     top: 0; left: 0;
    //     width: 100%; line-height: 1.2rem;
    //     color: #f9f9f9;
    //     font-size: .5rem;
    //     text-align: center;
    //     z-index: 0;
    // }
    &-body{
        position: absolute;
        top: @mg-default; left: @mg-default; right: @mg-default;
        z-index: 1;
    }
    &-footer{
        position: absolute;
        bottom: 0.08rem; left: @mg-default; right: @mg-default;
        &__price{ 
            color: #cd6c3b;
            margin: 2px 0 0 2px;
            &:before{
                content: '¥';
                font-size: .12rem;
                margin-right: .02rem;
            }
        }
    }
}

// 二维码
.qrcode-wrap{
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0,0,0,.5);
    z-index: 99;
    color: #fff;
    & #qrcode{
        position: fixed;
        top: 50%;
        left: 50%;
        border: 10px solid #fff;
        transform: translate(-50%, -50%);
        -o-transform: translate(-50%, -50%);
        -moz-transform: translate(-50%, -50%);
        -webkit-transform: translate(-50%, -50%);
        -ms-transform: translate(-50%, -50%);
    }
}
</style>



// WEBPACK FOOTER //
// src/components/MyCycleCard.vue